<div id="modulo">
  <div class="title-modulo">
    <span>Selecione o módulo</span>
  </div>
  <div class="box">
    <div class="btn-vendas" (click)="goSale()" *ngIf="visibleSale">
      <span class="po-icon po-icon-cart" style="font-size: 80px; margin-bottom: 20px;"></span>
      <br>
      <span>Lojas</span>
    </div>
    <div class="btn-vendedores" (click)="isDisabled ? openDoc() : goSalers()" *ngIf="visibleSale && visibleSalers" style="position: relative;">
      <div class="po-p-1" (click)="openDoc()" style="border-radius: 100px; color: white; background-color: rgb(204, 31, 31); position: absolute; top: -15px; left: 29%; font-size: 12px;">
        <span>Novidade</span>
        <span class="po-icon po-icon-notification po-ml-1"></span>
      </div>
      <span class="po-icon po-icon-users" style="font-size: 80px; margin-bottom: 20px;"></span>
      <br>
      <span>Vendedores</span>
    </div>
    <div class="btn-financeiro" (click)="goFinancial()" *ngIf="visibleFinancial">
      <span class="po-icon po-icon-finance-secure" style="font-size: 80px; margin-bottom: 20px;"></span>
      <br>
      <span>Financeiro</span>
    </div>
    <div class="btn-industrial" (click)="goManufacturing()" *ngIf="visibleManufacturing">
      <span class="po-icon po-icon-manufacture" style="font-size: 80px; margin-bottom: 20px;"></span>
      <br>
      <span>Industrial</span>
    </div>
  </div>
  <div class="box-center">
    <div class="btn-vendas" style="border: none;" *ngIf="ativeSale">
      <span class="po-icon po-icon-cart" style="font-size: 80px; margin-bottom: 20px;"></span>
      <br>
      <span>Lojas</span>
    </div>
    <div class="btn-vendedores" style="border: none;" *ngIf="ativeSeller && visibleSalers">
      <span class="po-icon po-icon-users" style="font-size: 80px; margin-bottom: 20px;"></span>
      <br>
      <span>Vendedores</span>
    </div>
    <div class="btn-financeiro" style="border: none;" *ngIf="ativeFinancial">
      <span class="po-icon po-icon-finance-secure" style="font-size: 80px; margin-bottom: 20px;"></span>
      <br>
      <span>Financeiro</span>
    </div>
    <div class="btn-industrial" style="border: none;" *ngIf="ativeManufacturing">
      <span class="po-icon po-icon-manufacture" style="font-size: 80px; margin-bottom: 20px;"></span>
      <br>
      <span>Industrial</span>
    </div>
  </div>
</div>